<template>
  <div class='account'>

  <navigator class='header' :title="title"></navigator>
    <div class="onehead" v-if="zhlist.length">
      <p><span>实收金额：<span class="jine">{{total_profits}}</span>元</span></p>
    </div>
    <div class="cont" v-if="zhlist.length">
      <div class="dbox" v-for="(item, index) in zhlist" :key="index">
        <p class="name">{{item.title}}<span>订单状态：{{item.orderStatus?orderStatusAll[item.orderStatus] : handleStatusList[0]}}</span></p>
        <p class="moey">支付金额：{{parseInt(item.orderFee)/100}}元</p>
        <p class="dd">订单ID：{{item.orderId}}</p>
        <p class="time">下单时间：{{item.createTime | DateFilter('yyyy-MM-dd hh:mm:ss')}}<span @click='detalis(item.orderId)'>查看详情</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast } from 'vant';

export default {
  data(){
    return {
      title: '账单',
      qiniuConfig: {},
      Newslist:[],
      zhlist:[],
      orderStatusAll:[
        '全部',
        '待审批',
        '审批中',
        '审批不通过',
        '用户取消',
        '待支付',
        '完成',
        '订单关闭',
        '已退款',
        '退款中',
      ],
      handleStatusList :[
        '待处理', '同意', '不同意',
      ],
      total_proceeds:'',
      total_profits:'',
    };
  },

  methods: {
    getUploadToken() {
      this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.qiniuConfig = res.resData;
        }
      });
    },
    getzhlist() {  // 流水列表
      this.$http.post(`${this.URL_PREFIX}/app/get/order/success/list`, {
        park_id: this.currentParkId,
        currPage: 1,
        pageRows: 15,
      },{
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.zhlist = res.resData.pageList;
          // this.total_profits = res.resData.total_profits;
          // this.total_proceeds = res.resData.total_proceeds;
          console.log(this.zhlist);
        }else{
          this.$toast(res.resDesc);
        }
      });
    },
    detalis(id) {
      this.$router.push({ path: `/BillDetalis/${id}` });
    },
  },
  computed: {
    ...mapGetters(['token', 'currentParkId']),
  },
  created() {
    this.getUploadToken();
    this.getzhlist();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.account{
  .header{
    // margin-bottom: .133333rem;
  }
  .onehead{
    background: #fff;
    margin-bottom: .13rem;
    p{
      height: 1rem;
      line-height: 1rem;
      padding: 0 .3222rem;
      .one{
        margin-right: .3rem;
      }
      span{
        .jine{
          color: #e62d28;
        }
      }
    }
  }
  .cont{
    .dbox{
      background: #fff;
      padding: .38rem;
      margin-bottom: .2rem;
      .name{
        font-size: .40rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
          font-size: .32rem;
          color: #5c5959;
        }
      }
      .moey{
        font-size: .32rem;
        color: #e62d28;
        padding-top: .06rem;
        padding-bottom: .2rem;
        border-bottom: 1px solid #efefef;
      }
      .dd{
        font-size: .3rem;
        color: #5c5959;
        margin: .1rem 0;
      }
      .time{
        font-size: .3rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
          font-size: .32rem;
          color: #e62d28;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/personal/Bill.vue